module.exports = __webpack_public_path__ + "static/media/logo.b5bf0a4a.svg";